<template>
  <transition
    enter-active-class="animate__animated animate__fadeIn"
    leave-active-class="animate__animated animate__fadeOut"
  >
    <v-snackbar v-model="success" :top="true" color="#28a745" timeout="2500">
      {{ message }}
    </v-snackbar>
  </transition>
</template>
  
  <script>
export default {
  name: "SuccessSnackbar",
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      success: true,
    };
  },
  methods: {
    updateVisibility() {
      this.success = !this.success;
      this.$emit("update-success", this.success);
    },
  },
  watch: {
    success() {
      this.updateVisibility();
    },
  },
};
</script>